<template>
  <b-navbar
    v-if="show_navbar"
    class="bg-white d-flex justify-content-around fixed-top"
  >
    <b-navbar-brand
      :to="$t('home_link') + '#pagetop'"
      class="d-flex align-items-center m-0"
    >
      <img
        src="@/assets/synaplus_logo_square256.svg"
        class="d-inline-block align-top"
        alt="Synaplus"
        style="height:60px;width:60px;"
      />
      <h4 class="ml-2">
        Synaplus
      </h4>
    </b-navbar-brand>

    <b-navbar-nav class="d-none d-lg-inline-flex font-alt">
      <b-nav-item href="#change">
        {{ $t('what_changes') }}
      </b-nav-item>
      <b-nav-item href="#support">
        {{ $t('support') }}
      </b-nav-item>
      <b-nav-item href="#engine">
        {{ $t('cosmo_engine') }}
      </b-nav-item>
      <b-nav-item href="#ecosystem">
        {{ $t('ecosystem') }}
      </b-nav-item>
      <b-nav-item href="#board">
        {{ $t('board') }}
      </b-nav-item>
      <div
        class="bg-tertiary mx-2"
        style="width: 1px; height: 25px; margin-top: 12px"
      />
      <b-nav-item-dropdown style="color: tertiary" :text="language_name">
        <b-dropdown-item
          v-for="(language_name, locale) in locale_to_language_name"
          @click="update_locale(locale)"
        >
          {{ language_name }}
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>

    <b-navbar-nav>
      <b-btn
        variant="primary font-alt"
        class="px-3 m-0"
        pill
        :to="$t('login_link')"
      >
        <span>{{ $t('connexion') }}</span>
        <i class="fas fa-angle-right ml-2" />
      </b-btn>
    </b-navbar-nav>
  </b-navbar>
</template>

<i18n>
{
  "en": {
    "what_changes": "What changes",
    "support": "Support",
    "cosmo_engine": "COsMO Engine",
    "ecosystem": "Ecosystem",
    "board": "Board",
    "connexion": "Connection"
  },
  "fr": {
    "what_changes": "Ce qui change",
    "support": "Accompagnement",
    "cosmo_engine": "COsMO Engine",
    "ecosystem": "Écosystème",
    "board": "Board",
    "connexion": "Connexion"
  }
}
</i18n>

<script>
import { mapState } from 'vuex'

export default {
  name: 'PageHeader',
  data() {
    return {
      locale_to_language_name: {
        fr: 'Français',
        en: 'English',
      },
    }
  },
  computed: {
    language_name() {
      return this.locale_to_language_name[this.locale]
    },
    ...mapState(['show_navbar', 'locale']),
  },
  methods: {
    update_locale(locale) {
      this.$emit('update_locale', locale)
    },
  },
}
</script>
